import { Colors, Icon } from '@amelio/ui-library';
import { useTranslation } from 'react-i18next';

import type { ReactNode } from 'react';

const ROW_CLASS = 'flex min-w-0 flex-wrap items-center gap-x-3 gap-y-2';

const LABEL_CLASS = 'shrink-0 text-[12px] font-semibold tracking-wider text-gray-400 uppercase';

const BOUND_CLASS =
    'flex min-w-0 items-center gap-3 max-sm:w-full max-sm:flex-col max-sm:items-stretch max-sm:gap-2';

const FIELD_CLASS = 'relative z-50 min-w-0 overflow-hidden';

const ARROW_CLASS = 'shrink-0 max-sm:hidden';

const ARROW_ICON_SIZE = 16;

interface DateRangeFieldsProps {
    startField: ReactNode;
    endField: ReactNode;
    dataTestId?: string;
}

export default function DateRangeFields({
    startField,
    endField,
    dataTestId,
}: DateRangeFieldsProps) {
    const { t } = useTranslation();

    return (
        <div
            className={ROW_CLASS}
            data-testid={dataTestId}
        >
            <div className={BOUND_CLASS}>
                <span className={LABEL_CLASS}>{t('common.dateRange.from')}</span>

                <div className={FIELD_CLASS}>{startField}</div>

                <span className={ARROW_CLASS}>
                    <Icon
                        name={'arrow-arrow-right'}
                        size={ARROW_ICON_SIZE}
                        color={Colors.BASE_300}
                        ariaHidden
                    />
                </span>
            </div>

            <div className={BOUND_CLASS}>
                <span className={LABEL_CLASS}>{t('common.dateRange.to')}</span>

                <div className={FIELD_CLASS}>{endField}</div>
            </div>
        </div>
    );
}
